import { render, staticRenderFns } from "./saveOnlineAction.vue?vue&type=template&id=6b59b985&"
import script from "./saveOnlineAction.vue?vue&type=script&lang=js&"
export * from "./saveOnlineAction.vue?vue&type=script&lang=js&"
import style0 from "./saveOnlineAction.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports